import Loadable from '../../components/loadable';

const BulkSmsCostWarningModal = Loadable({
  loader: () => import('../../pages/messages/message_drawer/bulk_sms_cost_warning_modal'),
  type: 'modal',
});

angular.module('shared').value('BulkSmsCostWarningModal', BulkSmsCostWarningModal);
